var _style, _path, _path2, _g, _g2, _g3, _line, _path3, _path4, _path5, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 397.9 500",
    style: {
      enableBackground: "new 0 0 397.9 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\n\t.st2{opacity:0.2;}\n\t.st3{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:#222F3E;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:#263238;}\n\t.st9{fill:#FECA57;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st10{fill:#222F3E;stroke:#222F3E;stroke-linecap:round;stroke-linejoin:round;}\n\t.st11{fill:#263238;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st12{fill:#F368E0;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st13{fill:#8C8C8C;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st14{fill:#222F3E;}\n\t.st15{fill:none;stroke:#757575;stroke-linecap:round;stroke-linejoin:round;}\n\t.st16{fill:url(#SVGID_2_);}\n\t.st17{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.9083,
    y1: -265.7741,
    x2: 390.7459,
    y2: -265.7741,
    gradientTransform: "matrix(1 0 0 1 0 450)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECA57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F368E0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.1,270.6c28.3-66.9,31.8-161.4-16.9-220.1C326.4,18,284.1,7.3,243.8,4.8C207.7,2.7,169,3.5,136.1,20.7 c-55.7,29-57,98-98.8,138.6c-33.6,32.8-47.6,79.6-18.9,141.1s82,75.4,134.5,55.8s76.3-23.8,139.4-13.9c29,4.5,50.1-17.3,62.8-40.7 C360.7,291.4,365.7,281.1,370.1,270.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.1,270.6c28.3-66.9,31.8-161.4-16.9-220.1C326.4,18,284.1,7.3,243.8,4.8C207.7,2.7,169,3.5,136.1,20.7 c-55.7,29-57,98-98.8,138.6c-33.6,32.8-47.6,79.6-18.9,141.1s82,75.4,134.5,55.8s76.3-23.8,139.4-13.9c29,4.5,50.1-17.3,62.8-40.7 C360.7,291.4,365.7,281.1,370.1,270.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "100.2,0 129.9,0 129.9,39.3 92.7,39.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "88.8,39.3 79.8,39.3 79.8,0 96.3,0  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 11.4,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 11.4,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.4,
    y: 11.4,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.8,
    y: 11.4,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.2,
    y: 11.4,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.6,
    y: 11.4,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 19,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 19,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.4,
    y: 19,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.8,
    y: 19,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.2,
    y: 19,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.6,
    y: 19,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 26.7,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 26.7,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.4,
    y: 26.7,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.8,
    y: 26.7,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.2,
    y: 26.7,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.6,
    y: 26.7,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.8,
    y: 5.4,
    className: "st3",
    width: 42.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "318.6,44.9 337.4,44.9 337.4,84.2 332.5,84.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "329.2,84.2 287.2,84.2 287.2,44.9 314.2,44.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 56.3,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.4,
    y: 56.3,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.9,
    y: 56.3,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.3,
    y: 56.3,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.7,
    y: 56.3,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.1,
    y: 56.3,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 64,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.4,
    y: 64,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.9,
    y: 64,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.3,
    y: 64,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.7,
    y: 64,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.1,
    y: 64,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 71.6,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.4,
    y: 71.6,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.9,
    y: 71.6,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.3,
    y: 71.6,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.7,
    y: 71.6,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.1,
    y: 71.6,
    className: "st3",
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.2,
    y: 50.3,
    className: "st3",
    width: 42.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55,107.8V87.3c0-1.4,1.1-2.6,2.5-2.6l0,0h32c1.4,0,2.5,1.1,2.5,2.6l0,0v29.5H55v-4.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 55.4,
    y1: 91.7,
    x2: 91.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "64.1,97.7 58.7,97.7 58.7,101.9 88.4,101.9 88.4,97.7 69.7,97.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.7,
    y: 106.5,
    className: "st3",
    width: 29.7,
    height: 4.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M215.6,7c-8.6-7.6-21.7-6.8-29.3,1.7c-7.2,8.1-7,20.5,0.7,28.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M189.4,39.1c9.2,6.8,22.2,4.8,29-4.4c5.8-7.8,5.3-18.7-1.1-26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "211.2,22.4 201.7,22.4 201.7,38.5  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.9,36.8c-5.7,0.9-9.6,6.2-8.7,11.9c0.8,5.1,5.2,8.9,10.3,8.9c1.2,0,2.5-0.2,3.7-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M63.6,54.8c4.2-3.9,4.5-10.5,0.6-14.7c-1.7-1.8-3.9-3-6.4-3.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 56.5,
    y1: 41.8,
    x2: 56.5,
    y2: 52.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 61.8,
    y1: 47.1,
    x2: 51.2,
    y2: 47.1
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 337.2,
    cy: 128.4,
    r: 10.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 337.2,
    y1: 123.1,
    x2: 337.2,
    y2: 133.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 342.5,
    y1: 128.4,
    x2: 331.9,
    y2: 128.4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Task_Panel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M339.6,486.5H85.5l0.3-407.4c0-8.2,3.4-14.8,7.6-14.8h238.9c4.2,0,7.6,6.6,7.6,14.8L339.6,486.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 264.7,
    y1: 102.9,
    x2: 330.5,
    y2: 102.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 99.9,
    y1: 102.9,
    x2: 260.9,
    y2: 102.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M332.3,57.3H93.4c-4.2,0-7.6,4.8-7.6,10.7v8.2h254.1V68C339.9,62.1,336.5,57.3,332.3,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M99.6,67.8c0-1.8-1-3.2-2.3-3.2S95,66,95,67.8s1,3.2,2.3,3.2S99.6,69.6,99.6,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.8,67.8c0-1.8-1-3.2-2.3-3.2s-2.3,1.4-2.3,3.2s1,3.2,2.3,3.2S108.8,69.6,108.8,67.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 115.6,
    cy: 67.8,
    rx: 2.3,
    ry: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M102.4,125.7v-13.2h-1.9V111h5v1.5h-1.9v13.2H102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M106.9,122.7l-0.4,3h-1.1l2-14.7h1.7l2,14.7H110l-0.4-3H106.9z M107.1,121.3h2.3l-1.2-8.5L107.1,121.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M116.6,114.5v0.4h-1.1v-0.5c0-1.3-0.4-2.1-1.2-2.1s-1.2,0.8-1.2,2.1c0,3.3,3.5,3.6,3.5,7.8 c0,2.2-0.8,3.7-2.3,3.7s-2.3-1.5-2.3-3.7v-0.8h1.1v0.9c0,1.3,0.4,2.1,1.2,2.1s1.2-0.8,1.2-2.1c0-3.3-3.5-3.6-3.5-7.7 c0-2.3,0.7-3.7,2.3-3.7S116.6,112.2,116.6,114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M119.4,119.3l-0.6,1.4v5h-1.2v-14.8h1.2v7.1l2.8-7.1h1.2l-2.6,6.7l2.7,8h-1.2L119.4,119.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M128.1,114.5v0.4H127v-0.5c0-1.3-0.4-2.1-1.2-2.1s-1.2,0.8-1.2,2.1c0,3.3,3.5,3.6,3.5,7.8 c0,2.2-0.8,3.7-2.3,3.7s-2.3-1.4-2.3-3.7v-0.8h1.1v0.9c0,1.3,0.4,2.1,1.2,2.1s1.2-0.8,1.2-2.1c0-3.3-3.5-3.6-3.5-7.7 c0-2.3,0.7-3.7,2.3-3.7S128.1,112.2,128.1,114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M329,165.1h-57.2c-1.9,0-3.4-2.1-3.4-4.7v-22.3c0-2.6,1.5-4.7,3.4-4.7H329c1.9,0,3.4,2.1,3.4,4.7v22.3 C332.4,163,330.9,165.1,329,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M275.2,32c-3.9,2-8,3.7-12.2,5.2c-4.1,1.3-8.6,3.2-9.8,7.2s-6.1,19.2-6.4,22.4c-0.3,3.2,4.8,9.1,4.8,9.1h66.5 c0,0,1.2-19-1.5-25.5s-11-12-13.4-13.1s-8.6-4.5-11.2-5C289.6,31.9,278.1,30.7,275.2,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M253.2,58.3c2.6-0.9,5.5-0.3,7.6,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.5,59.8c1.6,0.1,3,0.8,4.1,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M265.3,51.1c0.6,1.2,0.9,2.6,0.8,4c-0.2,2.7-0.8,5.3-1.7,7.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M263,48.5c0.6,0.4,1.2,1,1.7,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M267,50.9c0.7,2.6,0.9,5.3,0.6,7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M301.6,53.6c0,0-1.6,6.3-1.4,8.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "276.2,47.4 279.1,53.4 281.6,62.5 285.1,54.2 288.5,47.6 281.9,46.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 279.1,
    y1: 53.4,
    x2: 285.1,
    y2: 54.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M275.9,36.8c-0.8,1.2-1.4,2.4-1.8,3.8c-0.6,2.2-1.8,9.6-1.8,9.6s6.2-0.4,7.8-0.4s4.2,0.2,4.6,0.2 c0.5,0,7.7,4.9,7.7,4.9s1.3-8.3-0.2-13S281.1,31.6,275.9,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M279.2,47.1l2.5,6l5.1-6.5C286.9,46.5,282.1,48.2,279.2,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.7,114.8l-2.5,5.2c0,0-3,0.7-3.4,1.4c-0.8,1.6-1.7,3.2-2.7,4.7c-0.8,0.9-2.4,2.2-1,2.9s4-2.5,4-2.5 l1.4-0.9c0.1,1.4-0.1,2.9-0.5,4.3c-0.9,3-2,6.8-1.9,7.1c0.7,1.9,1.8,0.6,1.8,0.6l2.1-5.7l0.4-0.3l-0.4,6.5 c-0.1,1.2,0.9,2.6,1.7,1.4l1.9-6.9v6.2c0,1,0.8,1.7,1.6,1.5c0.1,0,0.1,0,0.2-0.1c0.6-0.4,0.9-7.9,0.9-7.9l1.3,5.4 c0.1,0.5,0.5,0.8,1,0.8c0.1,0,0.1,0,0.2,0s0.2-0.1,0.3-0.3c0.2-0.6-0.3-9.2-0.3-9.2l-0.3-9l0.5-3.1L300.7,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M303.7,54.3c0,0-2.5,6.1-2.2,8.3c0.3,2.2,7.8,22.9,7.8,22.9l-9.3,30.1l7.4,2c0,0,12.6-21.1,13.9-25.6 c0.8-2.6,1.1-5.3,1-7.9c0-1.1-3-25.8-4.7-30.1c-1-2.5-2.4-4.9-4-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M310.3,84.8c0,0,2.9-4.5,4.6-7.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 314.5,
    y1: 75.8,
    x2: 311,
    y2: 80.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 300.6,
    y1: 112.7,
    x2: 308.4,
    y2: 114.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M249.4,61.8c-0.8,0.8-1.4,1.6-2,2.5c-1.4,2.3-0.6,7.4,0.3,9s4.8,2.7,4.8,2.7h31.1l0.6-5.9h-1.1 c0,0-5.6-2-9.6-3.2s-11.9-5-14.2-5.6c-1.8-0.4-3.7-0.5-5.5-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M288.8,76l-0.2-0.2c0,0,3.2-0.3,3.7-0.5c0.6-0.2,1.2-0.3,1.8-0.3l4.7,1.1h4.6l-0.5-0.9l-4.2-2.9l-3.6-2 c-3.7-2.1-8.2,0.5-12.1-0.2l0.7,0.1l-0.6,5.8H288.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 295.2,
    y1: 71.9,
    x2: 302.6,
    y2: 75.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 281,
    y1: 69.8,
    x2: 280.8,
    y2: 75.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M274.9,26.5c-1.3-2.1-2.1-4.4-2.2-6.9c-0.2-3.8,1.4-4.5,1.4-4.5s-2.4-4.3,2.9-6.9s13.3-4,17.8-1.3 s6.1,9,5.9,13.4c-0.3,3.2-1.1,6.4-2.4,9.4l-3.5,4.9c0,0-2.2,0.9-2.7-0.2s-3.2-4.3-4.6-4.3s-5.1,0-7-0.9S274.9,26.5,274.9,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M274.6,21.1c0,0-0.2,11-0.2,13.4c-0.1,2.4,0.2,4.8,1,7c1,2.3,1.8,8.7,6.1,9c4.3,0.3,10.6-4.7,11.7-7.4 c0.8-2.4,1.4-4.9,1.8-7.4c0,0,3.8-2.9,4.5-6.3s-0.6-5-1.4-3.4s-1.9,5.8-2.4,6.1s-1.2-2.1-1.2-2.1s-2.4,1.1-2.7,0s1.3-6.3,1.3-6.3 c-2.1,0.7-4.2,1.2-6.4,1.6c-1.2-0.2-2.4-0.5-3.5-0.9l4.6,3.3c-2,0.9-4.3,1.1-6.4,0.5c-3.2-1.1-5.6-7-5.6-7L274.6,21.1L274.6,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M279.4,32.7v2.2c0,0-2.1,6.1-1.8,7.2s3.2,0.5,3.8,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M279.1,43.9c1.9,1.3,4.3,1.3,6.2,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.7,35.7c1.6,1.3,3.7,1.6,5.6,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.9,32.5c0,0,3.5-1.5,5.8,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M275.7,32.8c0,0,0.6,1.6,3.7,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M278.7,31c0,0-1.1-2.2-2.7-1.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "281.6,62.5 277,108.4 282.9,117.7 288.3,108.4  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M99,185.1v8.9c0,0,73.9-3.8,163.6-5.5L99,185.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.9,
    y: 133.4,
    className: "st5",
    width: 167.7,
    height: 55.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M95.5,195.7c0,0,2.3-5.9,2.7-6.5s1.2-2.1,2.6-2.1s3.8,0.1,4.8-0.3s2.4-0.5,2.1,0.4s-2.1,1.2-2.1,1.2l7.8,0.6 c-1,1-2.1,1.8-3.3,2.6c-1.1,0.4-2.2,0.7-3.3,0.9c-0.9,0.6-1.9,1.1-3,1.5c-1,0.2-2,0.4-3,0.4l-1.7,3L95.5,195.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 105.6,
    y1: 188.5,
    x2: 102.2,
    y2: 189.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "80.3,169.4 77.7,173.7 79.2,177.2 83.4,174 85.5,172.5 85.5,163.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M79.5,171.8c0,0,1.2-6.1,1.8-6.9c1.1-1.1,2.3-2,3.8-2.7c0.7-0.1,1.8,0.3,1.2,1.2c-0.8,0.9-1.6,1.6-2.6,2.3 c0,0,1,3,0.3,4.7c-0.5,1-1.4,1.9-2.4,2.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "77.3,172.9 79.8,179.4 66.8,189.3 63.9,179.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68.6,281.3l0.5,6.4c0,0-3.4,7.1-3,13.3c0.4,6.2,1,24.3,1,25.3s-1.7,2.2-0.5,6.4c0.3,1.2,3.2,0.3,6.1,2.2 c2.6,1.7,5.5,2.7,8.6,3c2.2,0,3.4,0,3.4-1s-3.2-2.4-4.6-3.7c-2.1-2.4-4.1-4.9-5.9-7.6c-0.3-0.7,1.2-10.6,2.2-14.5s3.8-13.1,5-19.7 s1.7-12,1.7-12L68.6,281.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M66.5,332.7l0.3,4.5h2.4l1-3.7C70.2,333.5,67.4,332.5,66.5,332.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M81.2,337.9c2.2-0.2,3.4,0,3.4-1s-3.2-2.4-4.6-3.7c-1.8-2.1-3.5-4.3-5.2-6.5c-0.7,0.5-1.5,0.9-2.4,1 c-1.9,0-3.7-0.5-5.4-1.4c0,1-1.7,2.2-0.5,6.4c0.3,1.2,3.3,1,5.6,3.7S80.9,338,81.2,337.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.9,276.4l0.3,9.4c0,0-4.4,5.9-5.2,11.6c-0.9,5.7-3.7,28.1-3.7,30.4s-1.4,9.3-0.7,9.8s8.4,0,8.4,0 c0.3-0.8,0.4-1.6,0.3-2.4c0-1.7-1.4-7.3-1-8.6c0.3-1.4,1.5-5.6,1.5-5.6s5.2-13.7,7.4-17.9c2.2-4.2,4.1-10.3,5.2-14 c1.2-3.7,2.2-8.9,2.2-8.9L48.9,276.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M47.3,326.9c-2.3-3.3-6.2-1.3-6.9-0.8c-0.1,0.9-0.1,1.5-0.1,1.8c0,2.2-1.3,9.3-0.7,9.8c0.7,0.5,8.4,0,8.4,0 c0.3-0.8,0.4-1.6,0.3-2.4C48.3,333.6,47.1,328.6,47.3,326.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M48,337.6c-0.3-1-2.7-5.1-2.7-5.1l-4.4,0.2c-1.5,1.7-1.4,4.9-1.4,4.9C40.2,338.1,48,337.6,48,337.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.3,332.5c0,0-1.5-1.4-2.7-0.9c-0.6,0.2-1.2,0.6-1.7,1l0.2,5h3L45.3,332.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.1,242.8c-0.9,2.5-1.4,5.1-1.5,7.8c-0.2,4.4,1,26,1,26s8.4,5.7,22.6,6.2s20.7-3.4,20.7-3.4s-0.3-26-2-32.2 s-4.7-8.8-4.7-8.8c-5.6,1.4-11.3,2-17,1.9c-5.8,0-11.7-0.7-17.4-2L45.1,242.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M49.6,190.9c0,0-4.2,7.8-4.8,13.5s5,23.1,5,23.7s-5.9,15.6-5.9,15.6c4.6,2,9.4,3.5,14.3,4.7 c5.5,1.2,11.2,1.2,16.7,0.1l2-5.9l0.8,5c0,0,0,0.1,2.4-0.4s5.4-3.2,5.4-3.2s-3.9-9.2-5.9-11.7c-1.9-2.6-4.4-8.4-4.4-8.4l0.9-7.5 c0,0,6.8,5.6,7.4,5.7s9.9-10.8,11.9-14s5.1-11.3,5.1-11.3l-4.5-2.3l-1.8,1.8l-10.7,11.6c0,0-6.5-7.4-9.6-8.6s-9.2-3-9.2-3 l-12.2-2.9l0.9-2.6C53.3,191.1,52.7,189.3,49.6,190.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "76,216.5 69.2,212.5 75.4,219.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M61.8,225.8c0.6,0.7,1.3,1.4,2.1,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M53.5,211.1c1.8,4.5,4.1,8.9,6.9,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M56.7,222.4c1.6,2.7,3.5,5.1,5.7,7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69.1,167.3c0.6,1.2,1.1,2.5,1.3,3.8c0.6,2.4,2.7,3.6,3.5,3.4s0.7,1.7,0.3,2.6c-0.3,0.6-0.7,1.2-1.2,1.6 c-0.1,2.1-0.3,4.2-0.6,6.3c-0.5,2.7-0.6,4.8-1.7,4.8h-5.4c0,0-0.5,2.4-0.6,4.4c-0.2,1.9-0.2,2.3-0.2,2.3l-12.2-2.9l1.4-4.2 c0,0-7.7-3.4-3.9-9.8S62.5,165.4,69.1,167.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "65.3,189.9 62.9,189.7 64.8,193.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M72.7,182.1c-0.9,0.6-2,0.6-3,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M68,172.7c0,0,0.3-2.9,1.8-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M70.4,173.9c0.3,0.8,0.2,1.5,0,1.6s-0.7-0.5-1-1.3s-0.2-1.5,0-1.6C69.7,172.6,70.2,173.1,70.4,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M69.1,162.8L69.1,162.8c1.6,2.1,1.4,4.5,0.1,6.6c-2.5,4.4-10.1,8.5-10.1,12.2s3.8,3.5,3.8,3.5 s1.5,3.3-2.3,6.1s-11.7,3.6-16.7-1.5c-1.4-1.5-2.4-3.3-2.9-5.2c-1.5-5.1-1.7-10.7,0.5-15.3c1.9-3.8,4-7,8-8.9 c3.1-1.5,7.9-1.9,11.4-1.7c1.7,0.1,3.3,0.5,4.8,1.2C67,160.6,68.2,161.6,69.1,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M58.6,188.2c0.7-0.1,1.5-0.3,2.2-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M65.2,171.3c-1,1.5-2.4,2.8-3.9,3.9c-5.3,3.7-11.1,7.6-8.5,11.1c0.9,1.2,2.4,2,3.9,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M67.5,166c-0.2,1-0.5,2-1,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M54.9,176.4c-0.9,1.2-2,2.6-3.3,4.1c-3.7,4.2-3.2,12.9,5.1,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M57.2,172.7c0,0-0.4,0.7-1.2,1.9"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 36.9,
    y1: 338.2,
    x2: 85.6,
    y2: 338.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.3422,
    y1: 578.3723,
    x2: 322.6622,
    y2: 578.3723,
    gradientTransform: "matrix(1 0 0 -1 0 958.66)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECA57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F368E0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M313.4,375.3c-2,0.3-3.3,2.2-3,4.2c0,0.1,0.1,0.3,0.1,0.4c0.5,2.1,2.7,3.7,4.6,4.5c2.2,1,7.6,0.9,7.6,0.9 s-1.2-3.5-1.3-3.8C320.2,379,316.4,374.9,313.4,375.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.7222,
    y1: 551.0718,
    x2: 389.1721,
    y2: 551.0718,
    gradientTransform: "matrix(1 0 0 -1 0 958.66)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECA57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F368E0"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M352.1,453c0.5-1.2,1.1-2.5,1.6-3.9s1.1-2.9,1.7-4.4c0.6,0.1,5.3,1.1,7.5,0.6c2-0.5,4.4-1.6,5.3-3.6 c0.9-1.8,0.2-4-1.7-4.9c-0.1-0.1-0.2-0.1-0.3-0.1c-2.9-1-7.4,2.3-9,4.6c-0.1,0.1-1,1.7-1.5,2.6c0.2-0.6,0.5-1.2,0.7-1.9 c0.5-1.3,0.9-2.6,1.4-3.9c0.2-0.7,0.4-1.4,0.6-2s0.4-1.4,0.5-2.1c0.4-1.7,0.7-3.4,1-5.1c1.1,0.4,5.1,1.8,7.2,1.6s4.6-0.9,5.8-2.7 c1.2-1.6,0.8-3.9-0.9-5.1c-0.1-0.1-0.2-0.1-0.3-0.2c-2.8-1.4-7.7,1.2-9.6,3.1c-0.1,0.1-1.4,1.7-2,2.5c0.2-1,0.3-2.1,0.5-3.1 c0.4-3.1,0.7-6.2,1-9.3c0.1-1,0.2-1.9,0.3-2.8c0.4,0.1,5.1,1.9,7.4,1.7c2.1-0.1,4.6-0.9,5.8-2.7c1.2-1.6,0.8-3.9-0.9-5.1 c-0.1-0.1-0.2-0.1-0.3-0.2c-2.8-1.4-7.7,1.2-9.6,3.1c-0.1,0.1-1.9,2.4-2.4,3c0.2-2.1,0.5-4.2,0.8-6.2c0.4-2.8,1-5.5,1.8-8.2 c0.2,0.1,5.1,1.9,7.5,1.8c2.1-0.1,4.6-0.9,5.8-2.7c1.2-1.6,0.8-3.9-0.9-5.1c-0.1-0.1-0.2-0.1-0.3-0.2c-2.8-1.4-7.7,1.2-9.6,3.1 c-0.1,0.1-2.1,2.6-2.4,3c0-0.1,0.1-0.3,0.1-0.5c0.8-2.7,1.9-5.2,3.2-7.7c0.7-1.4,1.5-2.6,2.2-3.9c0.9,0.4,4.9,2.4,7.1,2.5 s4.7-0.4,6.1-2.1c1.3-1.5,1.2-3.8-0.3-5.2c-0.1-0.1-0.2-0.2-0.3-0.2c-2.6-1.7-7.8,0.4-9.9,2.1c-0.1,0.1-1.2,1.2-2,2 c0.4-0.5,0.7-1.1,1-1.6c1.3-2,2.6-3.6,3.8-5.1c0.7-0.9,1.3-1.6,1.9-2.3c1.1,0,5.5-0.1,7.4-1s4-2.5,4.5-4.6c0.5-2-0.7-3.9-2.7-4.4 c-0.1,0-0.3-0.1-0.4-0.1c-3.1-0.3-6.7,3.9-7.8,6.4c-0.1,0.2-1.2,3.8-1.2,3.8h0.1c-0.6,0.7-1.2,1.4-1.9,2.2 c-1.2,1.5-2.5,3.1-3.9,5.1c-1.5,2.1-2.8,4.2-4,6.4c-1.4,2.5-2.5,5.1-3.4,7.8v0.1c0-0.9,0-3.4,0-3.6c-0.4-2.7-2.6-7.8-5.7-8.4 c-2-0.3-3.9,1.1-4.2,3.1c0,0.1,0,0.3,0,0.4c-0.2,2.2,1.4,4.4,2.9,5.7c1.7,1.5,6.5,3,6.9,3.2c-0.9,2.7-1.5,5.6-2,8.4 c-0.3,1.6-0.5,3.3-0.8,5c0-0.8,0-1.5,0-1.6c-0.4-2.7-2.6-7.8-5.7-8.4c-2-0.3-3.9,1.1-4.2,3.1c0,0.1,0,0.3,0,0.4 c-0.2,2.2,1.4,4.4,2.9,5.7s5.6,2.8,6.7,3.1c-0.1,0.6-0.2,1.3-0.2,1.9c-0.4,3.1-0.7,6.2-1.2,9.2c-0.2,1.1-0.4,2.1-0.5,3.2 c0-0.7,0-1.3,0-1.4c-0.4-2.7-2.6-7.8-5.7-8.4c-2-0.3-3.9,1.1-4.2,3.1c0,0.1,0,0.3,0,0.4c-0.2,2.2,1.4,4.4,2.9,5.7s5.2,2.6,6.5,3 c-0.2,1.1-0.5,2.1-0.7,3.1c-0.2,0.7-0.3,1.4-0.6,2.1l-0.7,2c-0.5,1.3-0.9,2.6-1.4,3.8c-0.3,0.9-0.7,1.7-1,2.5 c0.2-1.1,0.5-3.1,0.5-3.3c0-2.4-0.7-4.8-1.9-6.9c0-0.3,0-0.5,0-0.8c-0.3-2-2.1-3.4-4.1-3.2c-0.1,0-0.3,0-0.4,0.1 c-3,0.8-4.9,6-5,8.8c0,0.2,0.1,1.9,0.2,3c-0.1-0.6-0.3-1.3-0.5-2c-0.3-1.3-0.7-2.6-1-4c-0.2-0.7-0.4-1.4-0.6-2s-0.5-1.4-0.7-2.1 c-0.6-1.6-1.3-3.2-2-4.8c1.2-0.3,5.2-1.3,6.9-2.6s3.4-3.3,3.4-5.5c0.1-2-1.5-3.7-3.6-3.8c-0.1,0-0.3,0-0.4,0 c-3.1,0.3-5.7,5.2-6.3,7.9c0,0.2-0.2,2.1-0.3,3.2c-0.4-1-0.9-1.9-1.4-2.9c-1.4-2.8-2.9-5.5-4.3-8.3c-0.5-0.8-0.9-1.7-1.3-2.5 c0.4-0.1,5.3-1.2,7.1-2.6c1.6-1.3,3.4-3.3,3.4-5.5c0.1-2-1.5-3.7-3.6-3.8c-0.1,0-0.3,0-0.4,0c-3.1,0.3-5.7,5.2-6.3,7.9 c0,0.2-0.3,3.1-0.3,3.8c-1-1.9-1.9-3.7-2.8-5.6c-1.2-2.5-2.2-5.1-3-7.8c0.2,0,5.3-1.2,7.2-2.6c1.6-1.3,3.4-3.3,3.4-5.5 c0.1-2-1.5-3.7-3.5-3.8c-0.1,0-0.3,0-0.4,0c-3.1,0.3-5.7,5.2-6.3,7.9c0,0.2-0.3,3.3-0.3,3.8l-0.2-0.5c-0.8-2.7-1.3-5.4-1.6-8.2 c-0.2-1.5-0.3-3-0.3-4.5c1-0.1,5.4-0.7,7.3-1.8s3.7-2.9,3.9-5.1c0.3-2-1.1-3.8-3.1-4.1c-0.1,0-0.3,0-0.4,0c-3.1,0-6.3,4.6-7.1,7.2 c0,0.1-0.4,1.6-0.6,2.7c0-0.6,0-1.3,0-1.9c0-2.3,0.1-4.5,0.3-6.4c0.1-1.1,0.2-2,0.3-3c0.9-0.6,4.5-3.1,5.6-4.9s2-4.3,1.1-6.3 c-0.7-1.9-2.8-2.9-4.7-2.2c-0.1,0-0.2,0.1-0.3,0.1c-2.7,1.4-3.5,6.9-3,9.7c0,0.2,1.1,3.8,1.1,3.8l0,0c-0.1,0.9-0.2,1.8-0.4,2.8 c-0.2,1.9-0.4,4-0.4,6.4c-0.1,2.5,0,5.1,0.2,7.6c0.2,2.8,0.7,5.6,1.4,8.4v0.1c-0.5-0.8-1.9-2.9-2-3c-1.8-2.1-6.5-5.1-9.4-3.9 c-1.8,0.8-2.6,3-1.8,4.8c0.1,0.1,0.1,0.2,0.2,0.4c1,1.9,3.6,2.9,5.6,3.1c2.3,0.3,7.1-1.1,7.5-1.2c0.8,2.8,1.8,5.5,2.9,8.1 c0.7,1.5,1.4,3.1,2.1,4.6c-0.4-0.6-0.8-1.2-0.9-1.3c-1.8-2.1-6.5-5.1-9.4-3.9c-1.8,0.8-2.6,3-1.8,4.8c0.1,0.1,0.1,0.2,0.2,0.4 c1,1.9,3.6,2.9,5.6,3.1s6.2-0.8,7.3-1.1c0.3,0.6,0.6,1.2,0.9,1.8c1.4,2.8,2.8,5.6,4.1,8.3c0.5,1,0.9,2,1.3,2.9 c-0.4-0.6-0.7-1-0.8-1.1c-1.8-2.1-6.5-5.1-9.4-3.9c-1.8,0.8-2.6,3-1.8,4.8c0.1,0.1,0.1,0.2,0.2,0.4c1,1.9,3.6,2.9,5.6,3.1 s5.8-0.7,7.1-1.1c0.4,1,0.8,2,1.1,3c0.2,0.7,0.5,1.3,0.7,2l0.6,2.1c0.3,1.3,0.6,2.7,0.9,4c0.2,0.9,0.4,1.8,0.5,2.6 c-0.5-1-1.4-2.9-1.5-3c-1.5-2.3-5.7-6-8.7-5.2c-1.9,0.6-3.1,2.6-2.5,4.5c0,0.1,0.1,0.2,0.1,0.4c0.8,2,3.1,3.4,5.1,4 c2.2,0.7,7,0.1,7.6,0c0.3,1.4,0.5,2.8,0.8,4.2c0.4,2,0.6,3.8,0.9,5.5h-2.8v1.5c4.4,0.6,8.9,1.1,13.3,1.4v-3h-2V453z M350,453h-4.6 c-0.3-1.8-0.6-3.7-1.1-5.9c-0.3-1.5-0.6-3-1-4.6c1.4-0.6,2.9-1.2,4.2-2c1.6,1.7,5.6,3.7,6.2,4c-0.5,1.4-1.1,2.7-1.6,3.9 C351.3,450.1,350.6,451.6,350,453L350,453z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M343.3,453h-2.8 M340.5,453v33.5h13.3V453H352"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 349.5,
    y1: 486.9,
    x2: 356.9,
    y2: 486.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 343.1,
    y1: 486.9,
    x2: 346.1,
    y2: 486.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 85,
    y1: 486.9,
    x2: 341,
    y2: 486.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundMobile);
export default __webpack_public_path__ + "static/media/background-mobile.f707ebbadc9a17d164b157f8aab9bddb.svg";
export { ForwardRef as ReactComponent };